import React from "react";

interface FailIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const FailIcon: React.FC<FailIconProps> = ({ className, width = 16, height = 16 }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M8 15C9.93298 15 11.683 14.2165 12.9497 12.9497C14.2165 11.683 15 9.93298 15 8C15 6.06702 14.2165 4.31702 12.9497 3.05025C11.683 1.7835 9.93298 1 8 1C6.06702 1 4.31702 1.7835 3.05025 3.05025C1.7835 4.31702 1 6.06702 1 8C1 9.93298 1.7835 11.683 3.05025 12.9497C4.31702 14.2165 6.06702 15 8 15Z" 
        fill="#A91818" 
        stroke="#A91818" 
        strokeWidth="1.5" 
        strokeLinejoin="round"
      />
      <path 
        d="M5.45442 5.45379L10.5456 10.545M10.5456 5.45379L5.45442 10.545" 
        stroke="white" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
    </svg>
  );
};

export default FailIcon;
